import React, { useState } from "react";
import Button from "../../../../reusable-components/buttons/Button";
import TableWrapper from "../../../../reusable-components/table/TableWrapper";
import { linkTextPrimary } from "../../../../theme/lightTheme";

import { TAG_CONFIG_URL } from "../../../../api/api_routing_urls";
import axios from "../../../../api/axios";
import DeleteModal from "../../../../reusable-components/modals/DeleteModal";
import showToast from "../../../../utilities/notification/NotificationModal";
import { linkTextDanger } from "../../../../theme/lightTheme";

export default function TagList({
  tagList,
  getTagList,
  setEditTagDetails,
  setShowAddForm,
}) {
  const onClickEdit = (tag) => {
    setEditTagDetails(tag);
    setShowAddForm(true);
  };

  const [showDelete, setShowDelete] = useState(false);
  const [tagDeleteId, setTagDeleteId] = useState(null);

  const onClickDelete = async () => {
    // console.log("Received ID to delete: ", tagDeleteId);
    try {
      let response = "";
      if (tagDeleteId) {
        response = await axios.post(`${TAG_CONFIG_URL}/delete`, {
          tag_id: tagDeleteId,
        });
        setShowDelete(false);
      }

      if (response.status === 200) {
        showToast("Tag details has been deleted successfully.", "success");
        getTagList();
      } else {
        showToast("Tag details deletion failed.", "error");
      }
    } catch (error) {
      console.log("Delete Module Error", error);
    } finally {
      setTagDeleteId(null);
    }
  };

  return (
    <TableWrapper>
      <thead className="bg-white text-sm">
        <tr>
          <th
            scope="col"
            className="px-6 py-3 text-left font-medium text-gray-900 uppercase tracking-wider"
          >
            Sl No.
          </th>
          <th
            scope="col"
            className="px-6 py-3 text-left font-medium text-gray-900 uppercase tracking-wider"
          >
            Tag Name
          </th>
          <th
            scope="col"
            className="pl-6 pr-9 py-3 text-right font-medium text-gray-900 uppercase tracking-wider"
          >
            Actions
          </th>
        </tr>
      </thead>
      <tbody className="bg-white divide-y divide-gray-100 text-gray-600">
        {tagList?.length > 0 &&
          tagList?.map((tag, index) => (
            <tr key={index}>
              <td className="px-6 py-4 whitespace-nowrap text-sm">
                {index+1}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm">
                {tag.tag_name}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm">
                <div className="flex justify-end">
                  <Button
                    onClick={() => onClickEdit(tag)}
                    aria-label="Edit Tag Details"
                    className={linkTextPrimary}
                  >
                    Edit
                  </Button>
                  <Button
                    onClick={() => {
                      setTagDeleteId(tag?.tag_id || null);
                      setShowDelete(true);
                    }}
                    aria-label="Delete Tag Details"
                    className={linkTextDanger}
                  >
                    Delete
                  </Button>
                </div>
              </td>
            </tr>
          ))}
      </tbody>

      <>
        <DeleteModal
          open={showDelete}
          setOpen={setShowDelete}
          message={"This entry will be deleted. Are you sure?"}
          onDelete={onClickDelete}
        />
      </>
    </TableWrapper>
  );
}
